<template>
  <component
    :is="layout"
    :page="pageName"
  />
</template>
<script>
import PagesLayout from '~layouts/Pages'
import {mapActions, mapGetters} from "vuex";
export default {
  name: 'App',
  components: {
    PagesLayout
  },
  data () {
    return {
      pageName: ''
    }
  },
  computed: {
    layout () {
      return PagesLayout
    }
  },
  async created () {
    if (this.isStudentGetter()) {
      await this.getStudentByToken()
    }
    await this.getDepartments()
  },
  methods: {
    ...mapGetters('auth', [
      'isStudentGetter'
    ]),
    ...mapActions('pages/students', [
      'getStudentByToken',
      'getDepartments'
    ])
  },
  watch: {
    '$route.name' (value) {
      this.pageName = 'page-'.concat(this.$route.name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase())
    }
  }
}
</script>
